module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Street":"Straße","Zipcode":"PLZ","City":"Ort","Country":"Land","Default Billing":"Standard Rechnungsadresse","Default Shipping":"Standard Versandadresse"}}')
  delete Component.options._Ctor
}
